import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pageView } from '../utils/gtm';
import { captureAttributionFromLocation } from '../utils/attribution';

/**
 * SPA pageview tracker for GTM / GA4.
 * Container bootstrap lives in public/index.html (GTM-K923GBB8).
 * Do NOT inject a second gtm.js.
 *
 * GTM must trigger GA4 page_view / Ads conversion tags on Custom Event
 * `pageview` (and/or History Change). "All Pages" alone is not enough for SPA
 * or for re-firing after Consent Mode grant.
 */
const GoogleTagManager = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    captureAttributionFromLocation(location.search);

    let cancelled = false;
    let timer;

    const schedule = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        if (cancelled) return;
        pageView(location.pathname, document.title, i18n.language, location.search);
      }, 250);
    };

    schedule();

    const titleEl = document.querySelector('title');
    const observer = titleEl
      ? new MutationObserver(schedule)
      : null;
    if (observer && titleEl) {
      observer.observe(titleEl, { childList: true, characterData: true, subtree: true });
    }

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
      observer?.disconnect();
    };
  }, [location.pathname, location.search, i18n.language]);

  return null;
};

export default GoogleTagManager;
